import { createReduxSlice } from '../../../redux/ReduxSlice'
import { State } from 'app/types/redux-types'

const initialState: State<boolean> = {
  data: false,
  status: 'idle',
  error: null
}

const syncSlice = createReduxSlice({
  name: 'syncInProgress',
  initialState,
  reducers: {
    setSyncInProgress: (state, action) => {
      state.data = action.payload
      state.status = 'succeeded'
    },
    reset: () => initialState
  }
})

export const { setSyncInProgress, reset: resetSyncState } = syncSlice.actions
export default syncSlice.reducer
